$(function () {
    var body = $('body');
    var burger = $('.burger');
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            nav_reset();
            burger.focus();
        }
    });

    $(document).ready(function () {
        nav_wrap.find('ul li a').attr('tabindex', '-1');
    })

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        nav_wrap.find('ul li a').attr('tabindex', '-1');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        nav_wrap.find('ul li:first-child a').focus();
        nav_wrap.find('ul li a').attr('tabindex', '0');
    };

    $('.navwrap .nav ul li:first-child a').on('keydown', function (event) {
        if (event.which == 9 && event.shiftKey) {
            event.preventDefault();
            burger.addClass('monkey').focus();
        }
    });

    $('.navwrap .nav ul li:last-child a').on('keydown', function (event) {
        if (event.which == 9 && !event.shiftKey) {
            event.preventDefault();
            burger.addClass('giraffe').focus();
        }
    });

    $('.header-logo').on('keydown', function (event) {
        nav_reset();
    });
});
